var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndoorSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 34C48 30 32 30 10 34L10.1883 34.3138C11.0563 35.7605 11.6691 37.3456 12 39L13 47H67L68 39C68.3309 37.3456 68.9437 35.7605 69.8117 34.3138L70 34Z",
    fill: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34L9.91056 33.5081L9.19933 33.6374L9.57125 34.2572L10 34ZM70 34L70.4287 34.2572L70.8007 33.6374L70.0894 33.5081L70 34ZM13 47L12.5039 47.062L12.5586 47.5H13V47ZM67 47V47.5H67.4414L67.4961 47.062L67 47ZM10.1883 34.3138L9.75954 34.5711L10.1883 34.3138ZM12 39L12.4961 38.938L12.4939 38.9198L12.4903 38.9019L12 39ZM69.8117 34.3138L70.2405 34.5711L70.2405 34.5711L69.8117 34.3138ZM68 39L67.5097 38.9019L67.5061 38.9198L67.5039 38.938L68 39ZM10.0894 34.4919C32.0303 30.5027 47.9697 30.5027 69.9106 34.4919L70.0894 33.5081C48.0303 29.4973 31.9697 29.4973 9.91056 33.5081L10.0894 34.4919ZM13 47.5H67V46.5H13V47.5ZM9.57125 34.2572L9.75954 34.5711L10.617 34.0566L10.4287 33.7427L9.57125 34.2572ZM11.5039 39.062L12.5039 47.062L13.4961 46.938L12.4961 38.938L11.5039 39.062ZM70.2405 34.5711L70.4287 34.2572L69.5713 33.7427L69.383 34.0566L70.2405 34.5711ZM67.4961 47.062L68.4961 39.062L67.5039 38.938L66.5039 46.938L67.4961 47.062ZM69.383 34.0566C68.4855 35.5524 67.8518 37.1914 67.5097 38.9019L68.4903 39.0981C68.8099 37.4999 69.4019 35.9686 70.2405 34.5711L69.383 34.0566ZM9.75954 34.5711C10.5981 35.9686 11.1901 37.4999 11.5097 39.098L12.4903 38.9019C12.1482 37.1914 11.5145 35.5524 10.617 34.0566L9.75954 34.5711Z",
    fill: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 40V47H42V40C42 37 38 37 38 40Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 41.4999L18.0001 46.9999H21.5001L21.0001 41.4998C21.0001 38.4999 17.0001 38.9998 17.5 41.4999Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0388 40.9999L27.5388 46.9999H31.5388L31.0388 40.9999C31.0388 37.4999 26.5388 37.9999 27.0388 40.9999Z",
    fill: "white",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0388 41.4999L61.5 46.9999H58L58.5388 41.4998C58.5388 38.4999 62.5388 38.9998 62.0388 41.4999Z",
    fill: "white",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 40.9999L52 46.9999H48L48.5 40.9999C48.5001 37.4999 53 37.9999 52.5 40.9999Z",
    fill: "white",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 32.5C25.1905 28.7269 43.8571 23.4445 61 32.5",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorSpace);
export default __webpack_public_path__ + "static/media/Indoor_Space.54ca8872e89f5754cdc62f10bd6d0834.svg";
export { ForwardRef as ReactComponent };